import { schoolModeActionTypes } from './schoolModeActionTypes';

const { ENABLE_SCHOOL_MODE, ENABLE_AI_FEATURES } = schoolModeActionTypes;

export interface SchoolModeState {
  enabled: boolean;
  aiFeaturesAllowed: boolean;
}

export const schoolModeInitialState: SchoolModeState = {
  enabled: false,
  aiFeaturesAllowed: false,
};

const reducer = (schoolMode = schoolModeInitialState, action: AnyFixMe) => {
  switch (action.type) {
    case ENABLE_SCHOOL_MODE:
      return schoolMode.enabled === true
        ? schoolMode
        : { ...schoolMode, enabled: true };
    case ENABLE_AI_FEATURES:
      return schoolMode.aiFeaturesAllowed === true
        ? schoolMode
        : { ...schoolMode, aiFeaturesAllowed: true };
    default:
      return schoolMode;
  }
};

export default reducer;
